import { render, staticRenderFns } from "./CaseStudies.vue?vue&type=template&id=349b8524"
import script from "./CaseStudies.vue?vue&type=script&lang=js"
export * from "./CaseStudies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ElementsLink: require('/opt/build/repo/components/Elements/Link.vue').default})
